import { useTranslation } from 'react-i18next';

export const FlowFormFields = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col gap-7">{children}</div>;
};

export const FlowHeaderOptional = () => {
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });
  return (
    <span className="text-center text-xl text-white">
      {t('optional_header')}
    </span>
  );
};

export const FlowFormHorizontalFields = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col justify-evenly gap-4 md:flex-row md:gap-6">
      {children}
    </div>
  );
};
